import { COLORS } from '~styles/tokens';

export interface NotificationCategory {
  value: string;
  label: string;
  color: string;
}

export const NOTIFICATION_CATEGORIES: NotificationCategory[] = [
  { value: '', label: 'Todas', color: '' },
  { value: 'Tarefas', label: 'Tarefas', color: COLORS.warning },
  { value: 'Atendimento', label: 'Atendimento', color: COLORS.info },
  { value: 'Pedidos', label: 'Pedidos', color: '#10b981' },
  { value: 'Clientes', label: 'Clientes', color: COLORS.purple },
  { value: 'Oportunidades', label: 'Oportunidades', color: '#ec4899' },
  { value: 'Suporte', label: 'Suporte', color: '#6366f1' },
];

export const CATEGORY_COLORS: Record<string, string> = {
  'Tarefas': COLORS.warning,
  'Atendimento': COLORS.info,
  'Pedidos': '#10b981',
  'Clientes': COLORS.purple,
  'Oportunidades': '#ec4899',
  'Suporte': '#6366f1',
};

export const POLLING_INTERVAL = 30000;

export const ANIMATION_DURATION = 4000;
